<!--
  Логотип LiqPay — вимога LiqPay до сайту мерчанта, п.9:
  «розмістіть на вашому сайті актуальний логотип LiqPay».

  Показуємо на сторінці «Умови користування». На екранах оплати логотип не
  ставимо навмисно — там і так є рядок «Продовжуючи, ви приймаєте правила
  сервісу», а зайвий бренд поруч із назвою закладу читається як другий логотип.

  Нічого не рендерить, якщо у закладу інша платіжна система.
-->
<template>
  <img
    v-if="showLogo"
    class="liqpay-mark"
    :src="isDarkSurface ? whiteLogo : colorLogo"
    alt="LiqPay"
  />
</template>

<script>
import { store } from "@/store.js";
import { isLiqPay } from "@/utils/paymentTerms";
import colorLogo from "./liqpay.svg";
import whiteLogo from "./liqpay-white.svg";
import { isOnDarkSurface } from "@/utils/surface";

export default {
  name: "LiqPayMark",
  data() {
    return { colorLogo, whiteLogo, isDarkSurface: false };
  },
  computed: {
    // Платіжку беремо з getStart: на сторінці умов сокетного paymentType немає.
    showLogo() {
      return isLiqPay(store.activePaymentSystem);
    },
  },
  mounted() {
    // Тему ставлять на body до рендеру сторінок, тож рахуємо один раз.
    this.$nextTick(() => {
      if (this.$el && this.$el.parentElement) {
        this.isDarkSurface = isOnDarkSurface(this.$el);
      }
    });
  },
};
</script>

<style scoped>
.liqpay-mark {
  display: block;
  height: 18px;
  width: auto;
  margin: 0 auto;
  opacity: 0.9;
}
</style>
